export default "__VITE_ASSET__D1jcV1Eg__"